module.exports = __webpack_public_path__ + "img/img-for-clinic-rs.afd32ea.png";